"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KYBStatusEnum = void 0;
var KYBStatusEnum;
(function (KYBStatusEnum) {
    KYBStatusEnum["NOT_STARTED"] = "NOT_STARTED";
    KYBStatusEnum["INITIATED"] = "INITIATED";
    KYBStatusEnum["PENDING_REVIEW"] = "PENDING_REVIEW";
    KYBStatusEnum["APPROVED"] = "APPROVED";
    KYBStatusEnum["REJECTED"] = "REJECTED";
    KYBStatusEnum["COMPLETED"] = "COMPLETED";
})(KYBStatusEnum || (exports.KYBStatusEnum = KYBStatusEnum = {}));
